import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { FooterPagesService } from '../../../core/services/footer-pages.service';
import { AppNotifyService } from 'src/app/core/services/app-notify.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { LanguageTranslationService } from '../../../core/services/language-translation.service';
import { IContactUSLabel } from '../../../core/models';
@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  //#region member/variable declaration
  contactUsForm: FormGroup;
  saveInProcess: boolean;
  contactUsTxt: IContactUSLabel;
  //#endregion
  constructor(private formBuilder: FormBuilder, private footerPagesService: FooterPagesService, private appNotifyService: AppNotifyService, private languageTranslationService: LanguageTranslationService) { }

  ngOnInit() {
    this.loadLanguageTranslationData();
    this.contactUsForm = this.formBuilder.group({
      firstName: new FormControl(),
      lastName: new FormControl(),
      customerNumber: new FormControl(),
      comments: new FormControl(),
      phoneNumber: new FormControl(),
      email: new FormControl(),
    })
  }
  //#region Language translate
  loadLanguageTranslationData() {
    const controlNameList = [
      { controlName: "headingTextLbl" },
      { controlName: "firstNameLbl" },
      { controlName: "lastNameLbl" },
      { controlName: "emailLbl" },
      { controlName: "customerNumberLbl" },
      { controlName: "commentsLbl" },
      { controlName: "contactInfoLbl" },
      { controlName: "phoneNumberLbl" },
      { controlName: "invalidPhoneLbl" },
      { controlName: "cancelLbl" },
      { controlName: "saveLbl" },
      { controlName: "invalidEmailLbl" },      

    ];
    const componentName = "contactus";
    const response = this.languageTranslationService.getLanguageTranslationList(controlNameList, componentName);
    if (response.length > 0) {
      this.contactUsTxt = response[response.length - 1];
    }
  }

  //#endregion
  //#region label & variable declaration
  contacts = {
    headingTextLbl: " Kawneer would love to hear from you! We are always looking for ways to improve.Please complete the form below.",
    firstNameLbl:"First Name",
    lastNameLbl:"Last Name",
    emailLbl:"Email",
    customerNumberLbl:"Customer Number",
    commentsLbl:"Comments",
    contactInfoLbl:"Contact Information",
    phoneNumberLbl:"Phone Number",
    invalidPhoneLbl: "Phone number length should be minimum 10",
    cancelLbl: "Clear",
    saveLbl:"Save",
    isSubmitted: false,
    isEmptyFirstName: false,
    isEmptyPhoneNumber: false,
    isInvalidPhoneNumber: false,
    isEmptyEmail: false,
    isInvalidEmail: false,
    invalidEmailLbl: "Email address is invalid",
  }
  //#endregion
  //#region validation
  public checkEmail(email) {
    const regExp = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i;
    return regExp.test(String(email).toLowerCase());
  }
  emailLeave() {
    const controls = this.contactUsForm.controls;
    if (controls.email.value) {
      const res = this.checkEmail(controls.email.value);
      if (!res) {
        this.contacts.isInvalidEmail = true;
        this.contacts.isEmptyEmail = true;
      } else {
        this.contacts.isInvalidEmail = false;
        this.contacts.isEmptyEmail = false;
      }
    }
    else {
      this.contacts.isInvalidEmail = false;
      this.contacts.isEmptyEmail = true;
    }
  }
  protected validateContactUsForm(): boolean {
    let isValid = true;
    const controls = this.contactUsForm.controls;
    if (this.contacts.isSubmitted) {
      if (controls.firstName.value) {
        this.contacts.isEmptyFirstName = false;
      } else {
        this.contacts.isEmptyFirstName = true;
        isValid = false;
      }
      if (controls.email.value) {
        const res = this.checkEmail(controls.email.value);
        if (!res) {
          this.contacts.isInvalidEmail = true;
          this.contacts.isInvalidEmail = true;
          isValid = false;
        } else {
          this.contacts.isInvalidEmail = false;
          this.contacts.isEmptyEmail = false;
        }
      } else {
        this.contacts.isEmptyEmail = true;
        isValid = false;
      }
      if (controls.phoneNumber.value) {
        this.contacts.isEmptyPhoneNumber = false;
        if ((controls.phoneNumber.value as string).toString().length !== 10) {
          this.contacts.isEmptyPhoneNumber = true;
          this.contacts.isInvalidPhoneNumber = true;
          isValid = false;
        } else {
          this.contacts.isInvalidPhoneNumber = false;
          this.contacts.isInvalidPhoneNumber = false;
        }
      } else {
        this.contacts.isEmptyPhoneNumber = true;
        this.contacts.isInvalidPhoneNumber = false;
        isValid = false;
      }
    }
    return isValid;
  }
  //#endregion
  //#region reset form
  resetContactUsForm() {
    this.contactUsForm.reset();
    this.contacts.isSubmitted = false;
    this.contacts.isEmptyFirstName = false;
    this.contacts.isEmptyPhoneNumber = false;
    this.contacts.isInvalidPhoneNumber = false;
    this.contacts.isEmptyEmail = false;
    this.contacts.isInvalidEmail = false;
  }
  //#endregion
  //#region save
  save() {
    this.contacts.isSubmitted = true;
    if (!this.validateContactUsForm()) {
      return;
    }
    this.saveInProcess = true;
    const controls = this.contactUsForm.controls;
    const body = {
      contactId: 0,
      firstName: controls.firstName.value,
      lastName: controls.lastName.value,
      customerNumber: controls.customerNumber.value,
      comments: controls.comments.value,
      phoneNumber: controls.phoneNumber.value ? controls.phoneNumber.value.toString() : 0,
      email: controls.email.value,
      languageCode: localStorage.getItem('language'),
    }
    this.footerPagesService.saveContactUsForm(body).subscribe(response => {
      this.resetContactUsForm();
      this.saveInProcess = false;
      this.appNotifyService.notify(NotifyType.SUCCESS, 'Saved successfully!');

    })
  }
  //#endregion
}
